import { useSectionStore } from "../store/Section.js";
import { useSectionRender } from "../utils/useRender.js";
export var Copied = props => {
  var {
    Copied: Comp = {}
  } = useSectionStore();
  useSectionRender(Comp, props, 'Copied');
  return null;
};
Copied.displayName = 'JVR.Copied';